<template>
  <AppLayout>
    <div class="container mt-1">
      <div class="col-12 row d-flex align-items-stretch">
        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body d-flex flex-column align-items-center justify-content-start">
              <h5 class="card-title w-100">Dni urlopowe</h5>
              <div class="w-100 mb-3">
                <table class="table table-bordered table-hover">
                  <tbody>
                    <tr>
                      <td>Urlop przyznany na rok {{ selectedYear }} (dni)</td>
                      <td>{{ localTenRok }}</td>
                    </tr>
                    <tr>
                      <td>Urlop z {{ selectedYear - 1 }} roku (dni)</td>
                      <td>{{ localPoprzedniRok }} </td>
                    </tr>
                    <tr>
                      <td>Wypoczynkowe razem na rok {{ selectedYear }}</td>
                      <td>
                        <center>
                          <h5>{{ razemDniWolnych }}</h5>
                        </center>
                      </td>
                    </tr>
                    <tr>
                      <td>Wypoczynkowe wykorzystane</td>
                      <td>
                        <table style="width: 100%;">
                          <thead>
                            <tr>
                              <th style="width: 50%;">
                                <center>Wykorzystane</center>
                              </th>
                              <th style="width: 50%;">
                                <center>Pozostało</center>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="width: 50%;">
                                <center>
                                  <h5>{{ wykorzystanychDniWolnych }}</h5>
                                </center>
                              </td>
                              <td style="width: 50%;">
                                <center>
                                  <h5>{{ zostaloDniWolnych }}</h5>
                                </center>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>Suma godzin na przepustki<br>(pobrane z urlopu wypoczynkowego)</td>
                      <td>
                        <center>
                          <h5>{{ this.localGodzinyPrzepustkiIs }}</h5>
                        </center>
                        <table style="width: 100%;">
                          <thead>
                            <tr>
                              <th style="width: 50%;">
                                <center>Wykorzystane</center>
                              </th>
                              <th style="width: 50%;">
                                <center>Pozostało</center>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="width: 50%;">
                                <center>
                                  <h5>{{ this.localGodzinyPrzepustkiDel }}</h5>
                                </center>
                              </td>
                              <td style="width: 50%;">
                                <center>
                                  <h5>{{ this.localGodzinyPrzepustki }}</h5>
                                </center>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>


                    <tr v-if="ojcowskiUrlopy.length && selectedYear === new Date().getFullYear()">
                      <td>Urlop ojcowski</td>
                      <td>
                        <div v-if="ojcowskiUrlopy.length && selectedYear === new Date().getFullYear()" class="mt-3">
                          <div v-for="(leave, index) in ojcowskiUrlopy" :key="'ojc-' + index">
                            <div v-if="leave.usageByChild">
                              <p v-for="child in leave.usageByChild" :key="child.dziecko || 'no-child'">
                                <template v-if="child.dziecko">
                                  - dziecko {{ child.dziecko ? new Date(child.dziecko).toLocaleDateString() : '' }}:
                                  pozostało {{ child.remaining }} {{ leave.unit }}
                                </template>
                                <template v-else>
                                  pozostało {{ child.remaining }} {{ leave.unit }}
                                </template>
                              </p>
                            </div>
                            <div v-else>
                              <p>pozostało {{ leave.remaining }} {{ leave.unit }}</p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="rodzicielskiUrlopy.length && selectedYear === new Date().getFullYear()">
                      <td>Urlop rodzicielski</td>
                      <td>
                        <div v-if="rodzicielskiUrlopy.length && selectedYear === new Date().getFullYear()" class="mt-3">
                          <div v-for="(leave, index) in rodzicielskiUrlopy" :key="'rodz-' + index">
                            <div v-if="leave.usageByChild">
                              <p v-for="child in leave.usageByChild" :key="child.dziecko || 'no-child'">
                                <template v-if="child.dziecko">
                                  - dziecko {{ child.dziecko ? new Date(child.dziecko).toLocaleDateString() : '' }}:
                                  pozostało {{ child.remaining }} {{ leave.unit }}
                                </template>
                                <template v-else>
                                  pozostało {{ child.remaining }} {{ leave.unit }}
                                </template>
                              </p>
                            </div>
                            <div v-else>
                              <p>pozostało {{ leave.remaining }} {{ leave.unit }}</p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="selectedYear === new Date().getFullYear()" class="d-flex justify-content-center w-100">
                <vue-apexcharts type="donut" height="250" :series="wykresDane" :options="wykresOpcje" class="w-100" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <h5 class="card-title">Kalendarz</h5>
              <div class="calendar-container table-responsive">
                <div class="d-flex justify-content-between align-items-center mb-3 me-1 flex-wrap">
                  <div class="d-flex align-items-center flex-wrap gap-2 select-month-year">
                    <select class="form-select form-select-sm w-auto" v-model="currentYear" @change="updateCalendar">
                      <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                    </select>
                    <select class="form-select form-select-sm w-auto" v-model="currentMonth" @change="updateCalendar">
                      <option v-for="(month, index) in months" :key="index" :value="index">{{ month }}</option>
                    </select>
                  </div>
                  <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
                    <button class="btn btn-outline-success btn-sm" @click="prevMonth"><strong><</strong></button>
                    <button class="btn btn-outline-success btn-sm" @click="nextMonth"><strong>></strong></button>
                  </div>
                </div>
                <table class="calendar-table">
                  <thead>
                    <tr>
                      <th class="week-header">Tydz.</th>
                      <th v-for="day in daysOfWeek" :key="day">{{ day }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(week, wIndex) in calendarDays" :key="wIndex">
                      <td class="week-number">{{ getWeekNumber(week) }}</td>
                      <td v-for="(day, dIndex) in week" :key="day.date"
                        :class="['calendar-cell', isHoliday(day.date) ? 'bg-holiday' : (dIndex >= 5 ? 'bg-weekend' : '')]"
                        :style="{
                          backgroundColor: isHoliday2(day.date) ? '#00bfff' : getStatusColor(day.date)
                        }">
                        {{ day.day }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="calendar-legend mt-3 d-flex justify-content-center gap-3 flex-wrap">
                  <div class="legend-item d-flex align-items-center">
                    <div
                      style="width: 18px; height: 18px; background-color: red; border: 1px solid #000; margin-right: 4px;">
                    </div>
                    <span>Nieobecny</span>
                  </div>
                  <div class="legend-item d-flex align-items-center">
                    <div
                      style="width: 18px; height: 18px; background-color: blue; border: 1px solid #000; margin-right: 4px;">
                    </div>
                    <span>Delegacja</span>
                  </div>
                  <div class="legend-item d-flex align-items-center">
                    <div
                      style="width: 18px; height: 18px; background-color: yellow; border: 1px solid #000; margin-right: 4px;">
                    </div>
                    <span>Przepustka</span>
                  </div>
                  <div class="legend-item d-flex align-items-center">
                    <div
                      style="width: 18px; height: 18px; background-color: #eee3e3; border: 1px solid #000; margin-right: 4px;">
                    </div>
                    <span>Święta</span>
                  </div>
                  <div class="legend-item d-flex align-items-center">
                    <div
                      style="width: 18px; height: 18px; background-color: #00bfff; border: 1px solid #000; margin-right: 4px;">
                    </div>
                    <span>Dzień wolny</span>
                  </div>
                </div>

                <div class="col-12 row d-flex align-items-stretch mt-2 mb-5">
                    <div class="col-md-4">
                      <center><button class="btn btn-outline-primary btn-sm mt-2"
                          @click="openModal">+ Urlop</button></center>
                    </div>
                    <div class="col-md-4">
                      <center><button class="btn btn-outline-primary btn-sm mt-2"
                          @click="openModalP">+ Przepustka</button></center>
                    </div>
                    <div class="col-md-4">
                      <center><button class="btn btn-outline-primary btn-sm mt-2"
                          @click="openModal2">+ Delegacja</button></center>
                    </div>
                </div>
                <div v-if="holidays2.length > 0" class="col-12 row d-flex align-items-stretch mt-2 mb-5">
                  <div>
                    <strong>Zaplanowane dni wolne na rok {{ currentYear }}:</strong>
                  </div>
                  <ul>
                    <li v-for="(day, index) in holidays2" :key="index">{{ day }}</li>
                  </ul>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 row d-flex align-items-stretch">
        <div class="col-md-12 mb-4 me-4">
          <div class="card shadow-sm">
            <div class="card-body d-flex flex-column h-100">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h5 class="card-title">Złożone wnioski urlopowe - {{ selectedYear }}</h5>
                </div>
                <div>
                  <button class="btn btn-sm btn-outline-secondary me-2 mb-2" @click="changeYear(-1)">← Poprzedni
                    rok</button>
                  <button class="btn btn-sm btn-outline-secondary mb-2" @click="changeYear(1)">Następny rok →</button>
                </div>
              </div>
              <div><button class="btn btn-primary btn-sm ms-1 mb-2" @click="openModal">Wniosek o urlop</button></div>
              <div class="flex-grow-1 overflow-auto" style="min-height: 200px;">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th>#</th>
                        <th>Od</th>
                        <th>Do</th>
                        <th>Opis</th>
                        <th>Liczba dni</th>
                        <th>Status</th>
                        <th>Data utworzenia</th>
                        <th>Data zmiany</th>
                        <th>Opcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(urlopydane, index) in wnioskiUrlopowe" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ urlopydane.start ? new Date(urlopydane.start).toLocaleDateString() : '' }}</td>
                        <td>{{ urlopydane.end ? new Date(urlopydane.end).toLocaleDateString() : '' }}</td>
                        <td><span v-html="urlopydane.opis"></span>
                          <div v-if="urlopydane.dziecko">
                            ( na dziecko urodzone w dniu: {{ urlopydane.dziecko ? new
                              Date(urlopydane.dziecko).toLocaleDateString() : '' }})
                          </div>
                        </td>
                        <td>{{ urlopydane.wolnedni }}</td>
                        <td>
                          <div v-if="Number(urlopydane.iskadry_only) === 1">
                            <span class="p-1 m-0 d-inline-block alert alert-info w-50">
                              <center>Kadry</center>
                            </span>
                          </div>
                          <div v-else>
                            <span
                              :class="['p-1 m-0 d-inline-block', { 'alert alert-primary': urlopydane.status === 0, 'alert alert-success': urlopydane.status === 1, 'alert alert-danger': urlopydane.status === 2 || urlopydane.status === 3 }]">{{
                                StatusIdNaTekst(urlopydane.status) }}</span>
                            <span v-if="urlopydane.logi && urlopydane.logi.length"
                              @click="openModalLog(urlopydane.logi)" style="cursor: pointer; margin-left: 10px;"
                              title="Pokaż historię zmian"><i class="bi bi-clock-history"></i></span>
                          </div>
                        </td>
                        <td>
                          <div v-if="editingId === urlopydane.id" class="d-flex align-items-center gap-2">
                            <input type="date" class="form-control form-control-sm"
                              :value="formatDateToYMD(urlopydane.created_at)"
                              @input="urlopydane.created_at = $event.target.value" />
                            <button @click="updateCreatedDate(urlopydane)"
                              class="btn btn-sm btn-success">Zapisz</button>
                          </div>
                          <div v-else class="d-flex align-items-center gap-2">
                            <span>{{ formatDateToDisplay(urlopydane.created_at) }}</span>
                            <button @click="editCreatedDate(urlopydane.id)" class="btn btn-xs btn-outline-info"><i
                                class="bi bi-pencil"></i></button>
                          </div>
                        </td>
                        <td>{{ urlopydane.updated_at ? new Date(urlopydane.updated_at).toLocaleDateString() : '' }}</td>
                        <td v-if="urlopydane.status !== 2 && urlopydane.status !== 3 && urlopydane.id">
                          <button
                            v-if="Number(urlopydane.iskadry_only) !== 1 && urlopydane.status !== 0 && urlopydane.status !== 1 && urlopydane.typ_id !== 15"
                            class="btn btn-sm equal-width-btn btn-danger me-2 mt-2 mb-2"
                            @click="anuluj(urlopydane.id)"><i class="bi bi-x-circle me-2"></i>Anuluj</button>
                          <button
                            v-if="urlopydane.typ_id === 100 && urlopydane.status === 1"
                            class="btn btn-sm equal-width-btn btn-danger me-2 mt-2 mb-2" @click="anuluj(urlopydane.id)"><i
                              class="bi bi-x-circle me-2"></i>Anuluj</button>							
                          <button
                            v-if="Number(urlopydane.iskadry_only) !== 1 && urlopydane.status === 0 && urlopydane.typ_id !== 15"
                            class="btn btn-sm equal-width-btn btn-danger me-2 mt-2 mb-2" @click="usun(urlopydane.id)"><i
                              class="bi bi-x-circle me-2"></i>Usuń</button>
                          <button v-if="!urlopydane.podpis && urlopydane.status === 0"
                            class="btn btn-outline-warning btn-sm equal-width-btn me-2 mt-2 mb-2"
                            @click="openPodpisModal(urlopydane.id)">Dodaj podpis</button>
                          <a v-if="urlopydane.iskartka == 1 && urlopydane.typ_id !== 100 && urlopydane.typ_id !== 15"
                            :href="route('urlopy.kartka', urlopydane.id)"
                            class="btn btn-outline-info btn-sm equal-width-btn mt-2 mb-2" rel="noopener noreferrer"
                            target="_blank"><i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz wniosek</a>
                          <div
                            v-if="urlopydane.iskartka == 1 && urlopydane.kartka !== 1 && (urlopydane.status === 1 || urlopydane.status === 0) && urlopydane.typ_id !== 100 && urlopydane.typ_id !== 15"
                            class="alert alert-warning alert-xs  mt-1"
                            style="padding: 2px 8px; font-size: 0.75rem; line-height: 1.1;">Dostarczono wniosek do kadr!
                          </div>
                          <div v-if="urlopydane.iskartka == 1 && urlopydane.kartka !== 1 && urlopydane.typ_id === 15"
                            class="alert alert-warning alert-xs  mt-1"
                            style="padding: 2px 8px; font-size: 0.75rem; line-height: 1.1;">Dostarcz zwolnienie L4 do
                            kadr!
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 row d-flex align-items-stretch">
        <div class="col-md-12 mb-4 me-4">
          <div class="card shadow-sm">
            <div class="card-body d-flex flex-column h-100">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h5 class="card-title">Złożone wnioski o przepustkę - {{ selectedYear }}</h5>
                </div>
                <div>
                  <button class="btn btn-sm btn-outline-secondary me-2 mb-2" @click="changeYear(-1)">← Poprzedni
                    rok</button>
                  <button class="btn btn-sm btn-outline-secondary mb-2" @click="changeYear(1)">Następny rok →</button>
                </div>
              </div>
              <div><button class="btn btn-primary btn-sm ms-1 mb-2" @click="openModalP">Wniosek o przepustkę</button>
              </div>

              <div class="flex-grow-1 overflow-auto" style="min-height: 200px;">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th>#</th>
                        <th>Data wyjścia</th>
                        <th>Godzina wyjścia</th>
                        <th>Liczba godzin</th>
                        <th>Status</th>
                        <th>Data utworzenia</th>
                        <th>Data zmiany</th>
                        <th>Opcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(przepustkidane, index) in wnioskiPrzepustki" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ przepustkidane.data_wyjscia ? new Date(przepustkidane.data_wyjscia).toLocaleDateString()
                          : ''
                        }}</td>
                        <td>{{ przepustkidane.od_godziny }}</td>
                        <td>{{ przepustkidane.liczba_godzin }} <br> {{ TypPNaTekst(przepustkidane.typ) }}</td>
                        <td>
                          <span
                            :class="['p-1 m-0 d-inline-block', { 'alert alert-primary': przepustkidane.status === 0, 'alert alert-success': przepustkidane.status === 1 }]">{{
                              StatusIdNaTekst(przepustkidane.status) }}</span>
                        </td>
                        <td>
                          <div v-if="editingIdP === przepustkidane.id" class="d-flex align-items-center gap-2">
                            <input type="date" class="form-control form-control-sm"
                              :value="formatDateToYMD(przepustkidane.created_at)"
                              @input="przepustkidane.created_at = $event.target.value" />
                            <button @click="updateCreatedDateP(przepustkidane)"
                              class="btn btn-sm btn-success">Zapisz</button>
                          </div>
                          <div v-else class="d-flex align-items-center gap-2">
                            <span>{{ formatDateToDisplay(przepustkidane.created_at) }}</span>
                            <button @click="editCreatedPrzepustkaDate(przepustkidane.id)"
                              class="btn btn-xs btn-outline-info">
                              <i class="bi bi-pencil"></i>
                            </button>
                          </div>
                        </td>
                        <td>{{ przepustkidane.updated_at ? new Date(przepustkidane.updated_at).toLocaleDateString() : ''
                        }}
                        </td>
                        <td v-if="przepustkidane.id">
                          <button v-if="przepustkidane.status == 0"
                            class="btn btn-sm equal-width-btn btn-danger me-2 mt-2 mb-2"
                            @click="usunP(przepustkidane.id)"><i class="bi bi-x-circle me-2"></i>Usuń</button>
                          <button v-if="!przepustkidane.podpis_exists && przepustkidane.status === 0"
                            class="btn btn-outline-warning btn-sm equal-width-btn me-2 mt-2 mb-2"
                            @click="openPodpisModalP(przepustkidane.id)">Dodaj podpis</button>
                          <a v-if="przepustkidane.status != 3 && przepustkidane.status != 2"
                            :href="route('przepustka.kartka.user', przepustkidane.id)"
                            class="btn btn-outline-info btn-sm equal-width-btn mt-2 mb-2" rel="noopener noreferrer"
                            target="_blank"><i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz wniosek</a>
                          <div v-if="przepustkidane.kartka != 1" class="alert alert-warning alert-xs  mt-1"
                            style="padding: 2px 8px; font-size: 0.75rem; line-height: 1.1;">Dostarczono, oczekuje na
                            zatwierdzenie
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="isModalOpenPodpis" class="modal fade show" tabindex="-1" style="display: block;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Podpisanie wniosku</h5>
              <button type="button" class="btn-close" @click="closeModalPodpis"></button>
            </div>

            <div class="modal-body text-center">
              <p><strong>Podpisz się:</strong></p>
              <canvas ref="signaturePadCanvas" class="signature-canvas"
                style="border:2px solid #0dcaf0; border-radius:10px; background:#fff; max-width:90vw;">
              </canvas>
              <div class="d-flex justify-content-center gap-3 mt-3">
                <button class="btn btn-secondary btn-lg px-4 py-2" @click="clearSignature">Wyczyść</button>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="closeModalPodpis">Anuluj</button>
              <button class="btn btn-primary" @click="submitPodpis">Zapisz</button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isModalOpenPodpisP" class="modal fade show" tabindex="-1" style="display: block;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Podpisanie wniosku</h5>
              <button type="button" class="btn-close" @click="closeModalPodpisP"></button>
            </div>

            <div class="modal-body text-center">
              <p><strong>Podpisz się:</strong></p>
              <canvas ref="signaturePadCanvas" class="signature-canvas"
                style="border:2px solid #0dcaf0; border-radius:10px; background:#fff; max-width:90vw;">
              </canvas>
              <div class="d-flex justify-content-center gap-3 mt-3">
                <button class="btn btn-secondary btn-lg px-4 py-2" @click="clearSignature">Wyczyść</button>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="closeModalPodpisP">Anuluj</button>
              <button class="btn btn-primary" @click="submitPodpisP">Zapisz</button>
            </div>
          </div>
        </div>
      </div>


      <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Złóż wniosek urlopowy</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <p><strong>Rodzaj urlopu:</strong></p>
                  <select v-model="newLeave.id" class="form-select mb-2" @change="onLeaveTypeChange" required>
                    <option disabled value="">Wybierz rodzaj urlopu</option>
                    <option v-for="typ in filteredTypyUrlopow" :key="typ.id" :value="typ.id">{{ typ.nazwa }}</option>
                  </select>
                  <div v-if="hasOptionsForSelectedType" class="mt-2">
                    <p><strong>Dodatkowa opcja:</strong></p>
                    <select v-model="selectedOption" class="form-select">
                      <option disabled value="">Wybierz opcję</option>
                      <option v-for="opcja in opcjeUrlopow[selectedTypeId]" :key="opcja.id" :value="opcja.id">{{
                        opcja.nazwa
                      }}</option>
                    </select>
                  </div>
                  <div v-if="shouldSelectChild" class="mt-2">
                    <p><strong>Wybierz dziecko:</strong></p>
                    <select v-model="selectedChild" class="form-select">
                      <option disabled value="">Wybierz dziecko</option>
                      <option v-for="d in filteredDzieci" :key="d" :value="d">
                        {{ new Date(d).toLocaleDateString('pl-PL') }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <p><strong>Zakres dat:</strong></p>
                  <ejs-daterangepicker placeholder="Wybierz daty" :format="'dd/MM/yyyy'" :value="dateRange"
                    :firstDayOfWeek="1" :weekNumber="true" @change="onDateRangeChange" />
                  <div v-if="workingDaysCount !== null" class="mt-2 text-muted">Zaznaczono {{ workingDaysCount }} {{
                    workingDaysLabel }}</div>
                </div>
              </div>
              <div v-if="selectedTypeDescription" class="text-muted mt-2">{{ selectedTypeDescription }}</div>
              <div v-if="selectedOptionDescription" class="text-muted mt-2">{{ selectedOptionDescription }}</div>

              <div v-if="formError" class="alert alert-danger mt-3">
                Wypełnij wszystkie pola poprawnie.
              </div>

              <p><strong>Podpisz się:</strong></p>
              <canvas ref="signaturePadCanvas" class="signature-canvas"
                style="border:2px solid #0dcaf0; border-radius:10px; background:#fff; max-width:90vw;">
              </canvas>
              <div class="d-flex justify-content-center gap-3 mt-3">
                <button class="btn btn-secondary btn-lg px-4 py-2" @click="clearSignature">Wyczyść</button>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
              <button v-if="workingDaysCount !== null" class="btn btn-primary" @click="submitLeave">Złóż
                wniosek</button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isModalOpen2" class="modal fade show" tabindex="-1" style="display: block;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Wniosek delegacji</h5>
              <button type="button" class="btn-close" @click="closeModal2"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <p><strong>Zakres dat:</strong></p>
                  <ejs-daterangepicker placeholder="Wybierz daty" :format="'dd/MM/yyyy'" :value="dateRange"
                    :firstDayOfWeek="1" :weekNumber="true" @change="onDateRangeChange" />
                  <div v-if="workingDaysCount !== null" class="mt-2 text-muted">Zaznaczono {{ workingDaysCount }} {{
                    workingDaysLabel }}</div>
                </div>
                <div class="col-md-6">
                  <p><strong>Wybierz osoby biorące udział:</strong></p>
                  <multiselect v-model="form.delegacjaPracownicy" :options="pracownicy" :multiple="true"
                    placeholder="Wybierz pracowników" label="name" track-by="id" />
                </div>
                <div class="col-md-12 mt-3">
                  <label for="lokalizacja" class="form-label"><strong>Lokalizacja delegacji:</strong></label>
                  <input type="text" id="lokalizacja" v-model="form.lokalizacja" class="form-control"
                    placeholder="Np. Warszawa, Kraków..." />
                </div>
                <div class="col-md-12 mt-3">
                  <label for="celDelegacji" class="form-label"><strong>Cel delegacji:</strong></label>
                  <textarea id="celDelegacji" v-model="form.celDelegacji" class="form-control" rows="3"
                    placeholder="Opis w jakim celu jest dana delegacja"></textarea>
                </div>
              </div>
              <div v-if="formError" class="alert alert-danger mt-3">
                Wypełnij wszystkie pola poprawnie.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="closeModal2">Anuluj</button>
              <button v-if="workingDaysCount !== null" class="btn btn-primary" @click="submitLeave2">Złóż
                wniosek</button>
            </div>
          </div>
        </div>
      </div>


      <div v-if="isModalOpenLog" class="modal fade show" tabindex="-1"
        style="display: block; background: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Historia zmian</h5>
              <button type="button" class="btn-close" @click="closeModalLog"></button>
            </div>
            <div class="modal-body">
              <ul v-if="selectedLogs.length">
                <li v-for="log in selectedLogs" :key="log.id" class="mb-3">
                  <strong><i>{{ new Date(log.created_at).toLocaleString() }}</i><br />
                    {{ log.user_name }}</strong>: {{ log.akcja }}<br />
                  <span style="white-space: pre-wrap;">{{ log.opis }}</span><br />
                </li>
              </ul>
              <p v-else class="text-muted">Brak logów.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModalLog">Zamknij</button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isModalOpenP" class="modal fade show" tabindex="-1" style="display: block;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Przepustka jednorazowa</h5>
              <button type="button" class="btn-close" @click="closeModalP"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <label for="created_at" class="form-label"><strong>Data utworzenia:</strong></label>
                  <input type="date" v-model="created_at" id="created_at" class="form-control" />
                </div>
                <div class="col-md-6">
                  <label for="data_out" class="form-label"><strong>Data wyjścia:</strong></label>
                  <input type="date" v-model="data_out" id="data_out" class="form-control" />
                </div>
                <div class="col-md-6 mt-3">
                  <label for="godzina_start" class="form-label"><strong>Godzina wyjścia:</strong></label>
                  <input type="time" v-model="godzina_start" id="godzina_start" class="form-control" />
                </div>
				<div class="col-md-6 mt-3">
				  <label for="ile_godzin" class="form-label">
					<strong>Liczba godzin na przepustce:</strong>
				  </label>

				  <select v-model="ile_godzin" id="ile_godzin" class="form-control">
					<option disabled value="">Wybierz…</option>

					<option
					  v-for="option in godzinyOpcje"
					  :key="option.value"
					  :value="option.value"
					>
					  {{ option.label }}
					</option>
				  </select>
				</div>

                <div class="col-md-6 mt-3">
                  <label for="select" class="form-label"><strong>Godziny zostaną:</strong></label>
                  <select id="select" v-model="select" class="form-select">
                    <option value="0">Odjęte z nadgodzin</option>
                    <option value="1">Zaliczone na poczet urlopu</option>
                  </select>
                </div>
                <div v-if="select === '1'" class="col-md-6 mt-3">
                  <label>Przy wyborze <b>Zaliczone na poczet urlopu</b> zostanie pobrany 1 dzien urlopu wypoczynkowego z
                    przezaczeniem na przepustki,
                    liczba godzin z urlopu jaka pozostała do wybrania jest widoczna pod liczbą dni dostępnego
                    urlopu.</label>
                </div>
              </div>
              <div v-if="formError" class="alert alert-danger mt-3">
                Wypełnij wszystkie pola poprawnie.
              </div>
              <p><strong>Podpisz się:</strong></p>
              <canvas ref="signaturePadCanvas" class="signature-canvas"
                style="border:2px solid #0dcaf0; border-radius:10px; background:#fff; max-width:90vw;">
              </canvas>
              <div class="d-flex justify-content-center gap-3 mt-3">
                <button class="btn btn-secondary btn-lg px-4 py-2" @click="clearSignature">Wyczyść</button>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="closeModalP">Anuluj</button>
              <button class="btn btn-primary" @click="submitLeaveP">Zapisz wniosek</button>
            </div>
          </div>
        </div>
      </div>


    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import vueApexcharts from "vue3-apexcharts";
import Multiselect from '@suadelabs/vue3-multiselect';
import { DateRangePickerComponent } from "@syncfusion/ej2-vue-calendars";

export default {
  props: {
    urlopyUser: Array,
    typyUrlopow: Array,
    opcjeUrlopow: Object,
    tenRok: Number,
    poprzedniRok: Number,
    wnioskiUrlopowe: Array,
    wnioskiPrzepustki: Array,
    dzieci: Array,
    dzieciall: Array,
    pracownicy: Array,
    ojcowski: Number,
    rodzicielski: Number,
    ojcowski_dni: Number,
    rodzicielski_dni: Number,
	wnioskiRodzicielskiAll: Array,
	wnioskiOjcowskiAll: Array,
  },
  components: { AppLayout, vueApexcharts, 'ejs-daterangepicker': DateRangePickerComponent, Multiselect },
  data() {
    const now = new Date();
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");

    return {
	  ile_godzin: '', 
      godzinyOpcje: [],
      localGodzinyPrzepustki: '',
      localGodzinyPrzepustkiIs: '',
      localGodzinyPrzepustkiDel: '',
      localDniZeszyt: '',
      showLogs: null,
      editingId: null,
      editingIdP: null, selectedLogs: [],
      form: {
        delegacjaPracownicy: [],
        lokalizacja: '',
        celDelegacji: '',
      },

      months: [
        'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
        'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
      ],
      availableYears: this.generateYearRange(now.getFullYear() - 5, now.getFullYear() + 1),
      holidays2: [],

      currentMonth: today.getMonth(),
      currentYear: today.getFullYear(),
      daysOfWeek: ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb', 'Nd'],
      wnioskiUrlopowe: [],
      selectedTypeId: null,
      wnioskiPrzepustki: [],
      selectedOption: '',
      dateRange: null,
      workingDaysCount: null,
      wolnedni: null,
      selectedMonth: now.getMonth() + 1,
      selectedYear: now.getFullYear(),
      selectedChild: '',
      select: '0',
      created_at: `${yyyy}-${mm}-${dd}`,
      n_created_at: `${yyyy}-${mm}-${dd}`,
      data_out: `${yyyy}-${mm}-${dd}`,
      wykorzystanychDniWolnych: 0,
      newLeave: {
        start: '',
        end: '',
        id: '',
      },
      selectedItem: null,
      signaturePad: null,
      formError: false,
      isModalOpenPodpis: false,
      isModalOpenPodpisP: false,
      isModalOpen: false,
      isModalOpen2: false,
      isModalOpenLog: false,
      isModalOpenP: false,
      localTenRok: this.tenRok,
      localPoprzedniRok: this.poprzedniRok
    };
  },
  mounted() {
      //console.log('Odebrane dzieci z backendu:', this.dzieci);
	    //console.log('Odebrane dzieciall z backendu:', this.dzieciall);

    window.addEventListener("resize", this.resizeCanvas);
    window.addEventListener("orientationchange", this.resizeCanvas);
    this.fetchWnioski();
    this.fetchWolne();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.resizeCanvas);
    window.removeEventListener("orientationchange", this.resizeCanvas);
  },
  created() {
   const today = new Date()

    this.dateRange = [today, today]
    this.onDateRangeChange({ value: this.dateRange })
	
    for (let i = 0.5; i <= 8; i += 0.5) {
      const hours = Math.floor(i)
      const minutes = i % 1 === 0 ? '00' : '30'

      this.godzinyOpcje.push({
        value: i,
        label: `${hours}:${minutes}`
      })
    }
  },
  
  computed: {
    filteredDzieci() {
      const selectedTyp = this.filteredTypyUrlopow.find(t => t.id === this.newLeave.id);
      if (!selectedTyp || !this.dzieci || !Array.isArray(this.dzieci)) return [];

      const maxYears = selectedTyp.do_roku; // 1 dla ojcowskiego, 6 dla rodzicielskiego
      if (!maxYears) return this.dzieci;

      const now = new Date();

      return this.dzieci.filter(d => {
        const birthDate = new Date(d);
        const ageInYears = (now - birthDate) / (1000 * 60 * 60 * 24 * 365.25);
        return ageInYears < maxYears;
      });
    },
    ojcowskiUrlopy() {
      return this.dodatkoweUrlopy().filter(leave =>
        this.typyUrlopow.find(t => t.nazwa === leave.name)?.ojcowski === 1
      );
    },
    rodzicielskiUrlopy() {
      return this.dodatkoweUrlopy().filter(leave =>
        this.typyUrlopow.find(t => t.nazwa === leave.name)?.rodzicielski === 1
      );
    },

    calendarDays() {
      const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1);
      const lastDayOfMonth = new Date(this.currentYear, this.currentMonth + 1, 0);
      const startDay = (firstDayOfMonth.getDay() + 6) % 7; // poniedziałek jako pierwszy
      const totalDays = lastDayOfMonth.getDate();

      const days = [];
      let week = [];

      for (let i = 0; i < startDay; i++) {
        week.push({ day: '', date: null });
      }

      for (let d = 1; d <= totalDays; d++) {
        const date = new Date(this.currentYear, this.currentMonth, d);
        week.push({ day: d, date });

        if (week.length === 7) {
          days.push(week);
          week = [];
        }
      }

      if (week.length) days.push(week);

      return days;
    },

    shouldSelectChild() {
      const typ = this.typyUrlopow.find(t => t.id === Number(this.newLeave.id));
      return typ && (typ.ojcowski === 1 || typ.rodzicielski === 1);
    },

    workingDaysLabel() {
      if (this.workingDaysCount === 1) return 'dzień roboczy';
      if (this.workingDaysCount >= 2 && this.workingDaysCount <= 4) return 'dni robocze';
      return 'dni roboczych';
    },



    razemDniWolnych() {
      return (this.localTenRok || 0) + (this.localPoprzedniRok || 0);
    },
    filteredTypyUrlopow() {
      const u = this.urlopyUser[0];
      if (!u) return [];
      const dzieckoDate = this.getNajmlodszeDzieckoDate();
      //console.log('Najmłodsze dziecko:', dzieckoDate);
      const now = new Date();
      const wiekDziecka = dzieckoDate ? now.getFullYear() - dzieckoDate.getFullYear() - (now < new Date(now.getFullYear(), dzieckoDate.getMonth(), dzieckoDate.getDate()) ? 1 : 0) : null;
      const ojcowski = Number(u.ojcowski);
      const rodzicielski = Number(u.rodzicielski);

      const rokPoUrodzeniu = dzieckoDate ? new Date(dzieckoDate) : null;
      if (rokPoUrodzeniu) rokPoUrodzeniu.setFullYear(rokPoUrodzeniu.getFullYear() + 1);
      return this.typyUrlopow.filter(t => {



        if (!dzieckoDate && (t.ojcowski === 1 || t.rodzicielski === 1 || (t.do_roku !== null && t.do_roku !== undefined))) {
          return false;
        }
        if (t.ojcowski === 1 && ojcowski !== 1) {
          return false;
        }
        if (t.rodzicielski === 1 && rodzicielski !== 1) {
          return false;
        }
        if (t.do_roku !== null && t.do_roku !== undefined && wiekDziecka !== null && wiekDziecka > t.do_roku) {
          return false;
        }
        if (t.ojcowski === 1 && rokPoUrodzeniu && now > rokPoUrodzeniu) {
          return false;
        }
        if (t.kadry_only === 1) {
          return false;
        }
        return true;
      });
    },


    selectedTypeDescription() {
      const typ = this.typyUrlopow.find(t => t.id === Number(this.newLeave.id));
      return typ?.opis || '';
    },
    selectedOptionDescription() {
      if (!this.selectedOption || !this.opcjeUrlopow[this.selectedTypeId]) return '';
      const opcja = this.opcjeUrlopow[this.selectedTypeId].find(
        o => o.id === Number(this.selectedOption)
      );
      return opcja?.opis || '';
    },

    hasOptionsForSelectedType() {
      const typ = this.typyUrlopow.find(t => t.id === this.selectedTypeId);
      return typ && typ.opcje === 1 && this.opcjeUrlopow[this.selectedTypeId];
    },
    zostaloDniWolnych() {
      return this.razemDniWolnych - this.wykorzystanychDniWolnych;
    },

    wykresDane() {
      return [this.wykorzystanychDniWolnych, this.zostaloDniWolnych];
    },
    wykresOpcje() {
      return {
        labels: ["Wypoczynkowe wykorzystane", "Wypoczynkowe dostępne"],
        colors: ["#f39c12", "#27ae60"],
        legend: {
          position: "bottom"
        },
        dataLabels: {
          enabled: true
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Suma"
                }
              }
            }
          }
        }
      };
    }
  },
  watch: {
    currentYear(newYear, oldYear) {
      //console.log("Rok zmienił się z", oldYear, "na", newYear);
      this.selectedYear = newYear; // synchronizacja
      this.fetchWolne(); // pobierz dni wolne dla nowego roku
      this.fetchWnioski();
      this.updateCalendar(); // odśwież kalendarz
    },
    currentMonth(newMonth, oldMonth) {
      //console.log("Miesiąc zmienił się z", oldMonth, "na", newMonth);

      // jeśli zmiana miesiąca powoduje zmianę roku (prevMonth / nextMonth)
      const monthDate = new Date(this.currentYear, newMonth, 1);
      if (monthDate.getFullYear() !== this.selectedYear) {
        this.selectedYear = monthDate.getFullYear();
      }

      this.updateCalendar(); // odśwież kalendarz po zmianie miesiąca
    }
  },

  methods: {

    TypPNaTekst(typ) {
      switch (typ) {
        case 0: return '(z nadgodzin)';
        case 1: return '(z urlopu)';
        default: return '(z nadgodzin)';
      }
    },

    isHoliday2(dateInput) {
      if (!dateInput) return false;

      const dateStr = typeof dateInput === 'string'
        ? dateInput
        : this.formatDate(dateInput);

      const allHolidays = this.holidays2.flatMap(item => {
        if (item.includes(' - ')) {
          // zakres w formacie "YYYY-MM-DD - YYYY-MM-DD"
          const [start, end] = item.split(' - ').map(s => s.trim());
          const dates = [];
          let current = new Date(start);
          const endDate = new Date(end);

          while (current <= endDate) {
            const yyyy = current.getFullYear();
            const mm = String(current.getMonth() + 1).padStart(2, '0');
            const dd = String(current.getDate()).padStart(2, '0');
            dates.push(`${yyyy}-${mm}-${dd}`);
            current.setDate(current.getDate() + 1);
          }

          return dates;
        } else {
          // pojedyncza data
          const d = new Date(item.trim());
          const yyyy = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          return [`${yyyy}-${mm}-${dd}`];
        }
      });

      return allHolidays.includes(dateStr);
    },

    dodatkoweUrlopy() {
      if (!this.urlopyUser || !this.typyUrlopow) {
        return [];
      }
      const user = this.urlopyUser[0];

      const filteredTypes = this.typyUrlopow.filter(t => {
        if (t.ojcowski == 1 && this.ojcowski != 1) return false;
        if (t.rodzicielski == 1 && this.rodzicielski != 1) return false;
        return t.ojcowski == 1 || t.rodzicielski == 1;
      });

      const unitMap = {
        0: "dni",
        1: "tyg.",
        2: "mies."
      };

      const results = filteredTypes.map(type => {
        let unit = "dni";
        if (type.dni_tygodni !== null && type.dni_tygodni !== undefined) {
          unit = unitMap[type.dni_tygodni] || "dni";
        }

        const dzieci = this.dzieci || [];

        // Jeśli brak dzieci, pokaż zużycie bez podziału
        if (dzieci.length === 0) {
		let total = null;

if (type.ojcowski == 1) {
  total = 2;
} else if (type.rodzicielski == 1) {
  total = 9;
}
          const used = this.wnioskiUrlopowe.reduce((acc, req) => {
            if (req.typ_id === type.id && req.status === 1) {
              const workingDays = this.countWorkingDays(req.start, req.end);
              if (unit === "tyg.") {
                acc += workingDays / 5;
              } else if (unit === "mies.") {
                acc += workingDays / 21;
              } else {
                acc += workingDays;
              }
            }
            return acc;
          }, 0);

          return {
            name: type.nazwa,
            unit,
            usageByChild: [{
              dziecko: null,
              remaining: total ? Math.max(0, (total - used).toFixed(1)) : "n/d"
            }]
          };
        }

        // Oblicz użycie na każde dziecko osobno
        const usageByChild = dzieci
          .filter(dziecko => {
            if (!dziecko) return false;

            const birthDate = new Date(dziecko);
            const today = new Date();

            const ageInYears = (today - birthDate) / (1000 * 60 * 60 * 24 * 365.25);
            return !type.do_roku || ageInYears < type.do_roku;
          })
          .map(dziecko => {
   let used = 0;
const childObj = (this.dzieciall || []).find(d =>
  new Date(d.dziecko).toISOString().slice(0,10)
  === new Date(dziecko).toISOString().slice(0,10)
);

const total = this.getLimitForChild(dziecko, type);
    if (type.rodzicielski == 1) {
      // Liczymy wszystkie dni dla rodzicielskiego z całego okresu dla danego dziecka
      used = this.wnioskiRodzicielskiAll
        .filter(req => req.dziecko === dziecko)
        .reduce((acc, req) => {
          const workingDays = this.countDaysIncludingWeekends(req.start, req.end);
 		acc +=  Math.ceil(workingDays / 7);
          return acc;
        }, 0);
    }
else if (type.ojcowski == 1) {
      // Liczymy wszystkie dni dla rodzicielskiego z całego okresu dla danego dziecka
      used = this.wnioskiOjcowskiAll
        .filter(req => req.dziecko === dziecko)
        .reduce((acc, req) => {
          const workingDays = this.countDaysIncludingWeekends(req.start, req.end);
 		acc +=  Math.ceil(workingDays / 7);
          return acc;
        }, 0);
    }
	else {
      // Wszystkie inne typy urlopów pozostają bez zmian
      used = this.wnioskiUrlopowe.reduce((acc, req) => {
        if (
          req.typ_id === type.id &&
          req.status === 1 &&
          req.dziecko === dziecko
        ) {
          const workingDays = this.countWorkingDays(req.start, req.end);
          if (unit === "tyg.") {
            acc +=  Math.ceil(workingDays / 5);
          } else if (unit === "mies.") {
            acc += Math.ceil(workingDays / 21);
          } else {
            acc += workingDays;
          }
        }
        return acc;
      }, 0);
    }
            return {
              dziecko,
              remaining: total ? Math.max(0, (total - used).toFixed(1)) : "n/d"
            };
          });

        return {
          name: type.nazwa,
          unit,
          usageByChild
        };
      });

      return results;
    },
    isHoliday(dateInput) {
      if (!dateInput) return false;

      const dateStr = typeof dateInput === 'string'
        ? dateInput
        : this.formatDate(dateInput);

      const year = parseInt(dateStr.substring(0, 4));
      const holidays = this.getPolishHolidays(year);
      return holidays.includes(dateStr);
    },

    getPolishHolidays(year) {
      const fixedHolidays = [
        `${year}-01-01`,
        `${year}-01-06`,
        `${year}-05-01`,
        `${year}-05-03`,
        `${year}-08-15`,
        `${year}-11-01`,
        `${year}-11-11`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
      ];

      const easter = this.getEasterDate(year);
      const holidays = [...fixedHolidays];
      holidays.push(this.formatDate(easter));
      holidays.push(this.formatDate(new Date(easter.getTime() + 86400000))); // Poniedziałek wielkanocny
      holidays.push(this.formatDate(new Date(easter.getTime() + 60 * 86400000))); // Boże Ciało

      return holidays;
    },

    // Wielkanoc
    getEasterDate(year) {
      const f = Math.floor;
      const G = year % 19;
      const C = f(year / 100);
      const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
      const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
      const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
      const L = I - J;
      const month = 3 + f((L + 40) / 44);
      const day = L + 28 - 31 * f(month / 4);
      return new Date(year, month - 1, day);
    },

    // Formatowanie daty do YYYY-MM-DD
    formatDate(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      return `${y}-${m}-${d}`;
    },

    generateYearRange(start, end) {
      const years = [];
      for (let y = start; y <= end; y++) {
        years.push(y);
      }
      return years;
    },

    updateCalendar() { },

    getWeekNumber(week) {
      const firstValidDay = week.find(d => d.date);
      if (!firstValidDay) return '';

      const date = new Date(firstValidDay.date);
      date.setHours(0, 0, 0, 0);

      const day = date.getDay() || 7;
      date.setDate(date.getDate() + (4 - day));
      const yearStart = new Date(date.getFullYear(), 0, 1);
      const weekNum = Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
      return weekNum;
    },

    prevMonth() {
      const minYear = new Date().getFullYear() - 5;

      if (this.currentMonth === 0) {
        if (this.currentYear > minYear) {
          this.currentMonth = 11;
          this.currentYear--;
        } else {
          // osiągnęliśmy minimalny rok, nie zmieniamy nic
          return;
        }
      } else {
        this.currentMonth--;
      }

      this.selectedYear = this.currentYear;
      this.fetchWnioski();
      this.updateCalendar();
    },

    nextMonth() {
      const maxYear = new Date().getFullYear() + 1;

      if (this.currentMonth === 11) {
        if (this.currentYear < maxYear) {
          this.currentMonth = 0;
          this.currentYear++;
        } else {
          // osiągnęliśmy maksymalny rok, nie zmieniamy nic
          return;
        }
      } else {
        // jeśli jesteśmy w maksymalnym roku i grudniu, nie pozwalamy iść dalej
        if (this.currentYear === maxYear && this.currentMonth === 5) {
          return;
        }
        this.currentMonth++;
      }

      this.selectedYear = this.currentYear;
      this.fetchWnioski();
      this.updateCalendar();
    },

    getStatusColor(date) {
      if (!date) return '';

      const formatted = this.formatDateToYMD(date);

      for (const urlop of this.wnioskiUrlopowe) {
        const start = this.formatDateToYMD(new Date(urlop.start));
        const end = this.formatDateToYMD(new Date(urlop.end));

        if (formatted >= start && formatted <= end) {
          if (urlop.status === 1 && urlop.typ_id !== 100 && urlop.typ_id !== 25) return '#ff0000'; // nieobecność
          if (urlop.status === 1 && urlop.typ_id === 100) return '#0000ff'; // delegacja
          //  if (urlop.status === 1 && urlop.typ_id === 25) return '#f1ab48'; // Na przepustke

        }
      }

      for (const wniosekp of this.wnioskiPrzepustki) {
        const pdate = this.formatDateToYMD(new Date(wniosekp.data_wyjscia));
        if (formatted == pdate) {
          return 'yellow'; // przepustka
        }
      }
      return '';
    },

    async openModal() {
      this.isModalOpen = true;
      // Dynamiczne wczytanie biblioteki z CDN, jeśli jeszcze nie jest załadowana
      if (!window.SignaturePad) {
        await this.loadSignaturePadCDN();
      }

      this.$nextTick(() => {
        const canvas = this.$refs.signaturePadCanvas;
        if (!canvas) return;

        this.resizeCanvas();

        this.signaturePad = new window.SignaturePad(canvas, {
          penColor: "rgb(26, 65, 165)",
        });

        window.addEventListener("resize", this.handleResize);
        window.addEventListener("orientationchange", this.handleResize);
      });

    },

    closeModal() {
      this.isModalOpen = false;
      this.newLeave = { start: '', end: '', id: '', wolnedni: '' };
      this.selectedOption = '';
      this.selectedTypeId = null;
      this.selectedChild = '';
      this.workingDaysCount = null;
      this.workingDaysLabel = null;
      this.signaturePad = null;

      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("orientationchange", this.handleResize);

    },
    resizeCanvas() {
      const canvas = this.$refs.signaturePadCanvas;
      if (!canvas) return;

      const rect = canvas.getBoundingClientRect();
      const ratio = window.devicePixelRatio || 1;

      canvas.width = rect.width * ratio;
      canvas.height = rect.height * ratio;

      const ctx = canvas.getContext("2d");
      ctx.scale(ratio, ratio);
    },

    clearSignature() {
      const canvas = this.$refs.signaturePadCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.signaturePad) this.signaturePad.clear();
    },
    async openPodpisModal(item) {
      this.selectedItem = item;
      this.isModalOpenPodpis = true;

      // Dynamiczne wczytanie biblioteki z CDN, jeśli jeszcze nie jest załadowana
      if (!window.SignaturePad) {
        await this.loadSignaturePadCDN();
      }

      this.$nextTick(() => {
        const canvas = this.$refs.signaturePadCanvas;
        if (!canvas) return;

        this.resizeCanvas();

        this.signaturePad = new window.SignaturePad(canvas, {
          penColor: "rgb(26, 65, 165)",
        });

        window.addEventListener("resize", this.handleResize);
        window.addEventListener("orientationchange", this.handleResize);
      });
    },
    async openPodpisModalP(item) {
      this.selectedItem = item;
      this.isModalOpenPodpisP = true;

      // Dynamiczne wczytanie biblioteki z CDN, jeśli jeszcze nie jest załadowana
      if (!window.SignaturePad) {
        await this.loadSignaturePadCDN();
      }

      this.$nextTick(() => {
        const canvas = this.$refs.signaturePadCanvas;
        if (!canvas) return;

        this.resizeCanvas();

        this.signaturePad = new window.SignaturePad(canvas, {
          penColor: "rgb(26, 65, 165)",
        });

        window.addEventListener("resize", this.handleResize);
        window.addEventListener("orientationchange", this.handleResize);
      });
    },
    handleResize() {
      if (!this.signaturePad) return;
      const data = this.signaturePad.toData(); // zachowaj podpis
      this.resizeCanvas(); // przeskaluj canvas
      this.signaturePad.fromData(data); // przywróć podpis
    },
    loadSignaturePadCDN() {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = '/js/signature_pad.umd.min.js';
        script.onload = () => resolve();
        script.onerror = reject;
        document.body.appendChild(script);
      });
    },

    async submitPodpis() {
      if (!this.signaturePad || this.signaturePad.isEmpty()) {
        this.showToast('error', 'Błąd', 'Dodaj podpis przed zapisaniem.');
        return;
      }

      const podpisDataUrl = this.signaturePad.toDataURL('image/png');

      try {
        await axios.put(route('urlopy.createPodpis', this.selectedItem), {
          podpis: podpisDataUrl,
        });
        this.showToast('success', 'Zapisano', 'Podpis został zapisany.');
        this.fetchWnioski(); // odświeżenie listy
        this.closeModalPodpis();
      } catch (err) {
        console.error(err);
        alert('Błąd podczas zapisu podpisu.');
        this.showToast('error', 'Błąd', 'Nie udało się zapisać podpisu.');
      }
    },

    async submitPodpisP() {
      if (!this.signaturePad || this.signaturePad.isEmpty()) {
        this.showToast('error', 'Błąd', 'Dodaj podpis przed zapisaniem.');
        return;
      }

      const podpisDataUrl = this.signaturePad.toDataURL('image/png');

      try {
        await axios.put(route('urlopy.przepustka.createPodpis', this.selectedItem), {
          podpis: podpisDataUrl,
        });
        this.showToast('success', 'Zapisano', 'Podpis został zapisany.');
        this.fetchWnioski(); // odświeżenie listy
        this.closeModalPodpisP();
      } catch (err) {
        console.error(err);
        alert('Błąd podczas zapisu podpisu.');
        this.showToast('error', 'Błąd', 'Nie udało się zapisać podpisu.');
      }
    },

    closeModalPodpis() {
      this.isModalOpenPodpis = false;
      this.signaturePad = null;

      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("orientationchange", this.handleResize);
    },
    closeModalPodpisP() {
      this.isModalOpenPodpisP = false;
      this.signaturePad = null;

      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("orientationchange", this.handleResize);
    },
    async openModal2() {
      this.isModalOpen2 = true;
    },

    closeModal2() {
      this.isModalOpen2 = false;

    },
    async openModalP() {
      this.isModalOpenP = true;
      if (!window.SignaturePad) {
        await this.loadSignaturePadCDN();
      }

      this.$nextTick(() => {
        const canvas = this.$refs.signaturePadCanvas;
        if (!canvas) return;

        this.resizeCanvas();

        this.signaturePad = new window.SignaturePad(canvas, {
          penColor: "rgb(26, 65, 165)",
        });

        window.addEventListener("resize", this.handleResize);
        window.addEventListener("orientationchange", this.handleResize);
      });
    },

    closeModalP() {
      this.isModalOpenP = false;
      this.created_at = this.n_created_at;
      this.data_out = this.n_created_at;
      this.godzina_start = null;
      this.ile_godzin = null;
      this.select = 0;
      this.signaturePad = null;

      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("orientationchange", this.handleResize);
    },
    async openModalLog(logi) {
      this.selectedLogs = logi;
      this.isModalOpenLog = true;
    },

    closeModalLog() {
      this.selectedLogs = [];
      this.isModalOpenLog = false;

    },

    getNajmlodszeDzieckoDate() {
      if (!this.dzieci || this.dzieci.length === 0) return null;

      const posortowane = [...this.dzieci]
        .map(d => new Date(d))
        .sort((a, b) => b - a); // malejąco, najmłodsze na początku

      return posortowane[0];
    },

    toLocalDate(dateStr) {
      const [y, m, d] = this.formatDate(dateStr).split('-').map(Number);
      return new Date(y, m - 1, d, 0, 0, 0);
    },

    obliczWykorzystaneDniWolne() {
      if (!this.wnioskiUrlopowe || !Array.isArray(this.wnioskiUrlopowe)) {
        this.wykorzystanychDniWolnych = 0;
        return;
      }

      const year = this.selectedYear;
      let suma = 0;

      this.wnioskiUrlopowe.forEach(wniosek => {
        if (wniosek.status !== 1) return; // tylko zatwierdzone
        const typ = this.typyUrlopow.find(t => t.id === wniosek.typ_id);
        if (!typ || typ.wypoczynkowy !== 1) return;
        //  const createdAt = new Date(wniosek.created_at);
        //  if (createdAt.getFullYear() !== year) return;

        const start = new Date(wniosek.start);
        const end = new Date(wniosek.end);

        const yearStart = new Date(year, 0, 1);  // 01.01 wybranego roku
        const yearEnd = new Date(year, 11, 31); // 31.12 wybranego roku

        const realStart = start < yearStart ? yearStart : start;
        const realEnd = end > yearEnd ? yearEnd : end;


        //suma += this.countWorkingDays(start, end);
        suma += this.countWorkingDays(realStart, realEnd);
      });

      this.wykorzystanychDniWolnych = suma;
    },

    getTypeNameById(id) {
      const found = this.typyUrlopow.find(t => t.id === id);
      return found ? found.nazwa : String(id);
    },

    getOptionNameById(id) {
      const opcje = this.opcjeUrlopow?.[this.selectedTypeId] || [];

      if (!Array.isArray(opcje)) {
        //console.warn('Brak opcji dla typu urlopu:', this.selectedTypeId);
        return String(id);
      }

      const opt = opcje.find(o => o.id === id);
      return opt ? opt.nazwa : String(id);
    },

    anuluj(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Anulowanie wniosku',
        html: 'Czy na pewno chcesz anulować wybrany wniosek?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(route('urlopy.anuluj', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Wniosek został anulowany',
              });
              this.fetchWnioski();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się anulować wniosku',
                text: error.response?.data?.message || 'Wystąpił błąd podczas anulowania',
              });
            });
        }
      });
    },

    anulujP(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Odrzucenie przepustki',
        html: 'Czy na pewno chcesz odrzucić wybraną przepustkę?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(route('urlopy.anuluj_przepustka', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Przepustka została odrzucona',
              });
              this.fetchWnioski();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się odrzucić przepustki',
                text: error.response?.data?.message || 'Wystąpił błąd podczas odrzucenia przepustki',
              });
            });
        }
      });
    },



    fetchWnioski() {
      const rok = this.selectedYear;

      axios.get(route('urlopy.get'), {
        params: { rok }
      })
        .then(response => {
          this.wnioskiUrlopowe = response.data.wnioski;
          this.wnioskiPrzepustki = response.data.przepustki;
          this.localGodzinyPrzepustki = response.data.godzinyPrzepustki;
          this.localGodzinyPrzepustkiIs = response.data.godzinyPrzepustkiIs;
          this.localGodzinyPrzepustkiDel = response.data.godzinyPrzepustkiDel;
		  this.localDniZeszyt = response.data.dni_zeszyt;
 
          this.localTenRok = response.data.posiadaneUrlopy.tenRok;
          this.localPoprzedniRok = response.data.posiadaneUrlopy.poprzedniRok;

          this.obliczWykorzystaneDniWolne();
        })
        .catch(error => {
          console.error("Błąd podczas pobierania wniosków urlopowych:", error);
        });
    },

    fetchWolne() {
      const rok = this.currentYear;
      //console.log("rok:", rok);

      axios.get(route('wolne.dni', { year: rok }))
        .then(response => {
          this.holidays2 = response.data;
          //console.log("holidays:", this.holidays2);
        })
        .catch(error => {
          console.error("Błąd podczas pobierania dni wolnych:", error);
        });
    },


    StatusIdNaTekst(status) {
      switch (status) {
        case 0: return 'Oczekuje';
        case 1: return 'Zatwierdzony';
        case 2: return 'Odrzucony';
        case 3: return 'Anulowany';
        default: return 'Nieznany';
      }
    },
    changeYear(delta) {
      const now = new Date();
      const currentYear = now.getFullYear();
      const newYear = this.selectedYear + delta;

      if (newYear >= currentYear - 5 && newYear <= currentYear + 1) {
        this.selectedYear = newYear;
        this.currentYear = newYear; // synchronizacja
        this.fetchWnioski();
        this.updateCalendar();
      }
    },
getLimitForChild(dziecko, type) {
  const user = this.urlopyUser?.[0] || {};

  const normalize = d =>
    new Date(d).toISOString().slice(0,10);

  const childObj = (this.dzieciall || []).find(d =>
    normalize(d.dziecko) === normalize(dziecko)
  );

  if (type.ojcowski == 1) {
    return parseFloat(childObj?.ojcowski_dni ?? 2); // <- usuń fallback usera
  }

  if (type.rodzicielski == 1) {
    return parseFloat(childObj?.rodzicielski_dni ?? 9); // <- usuń fallback usera
  }

  return 0;
},

    shouldBlockSpecialLeave(typeId, start, end, seloptionID = null, newRequestDays = null) {
      const currentYear = new Date().getFullYear();
      const typ = this.typyUrlopow.find(t => t.id === typeId);
      if (!typ) return { blocked: false };

      for (const req of this.wnioskiUrlopowe) {
        if (req.status === 2 || req.status === 3) {
          continue; // pomiń odrzucone lub anulowane wnioski
        }

        const reqStart = new Date(req.start);
        const reqEnd = new Date(req.end);
        const newStart = new Date(start);
        const newEnd = new Date(end);

        if (newStart <= reqEnd && newEnd >= reqStart) {
          return { blocked: true, reasonCode: 'overlapExists' };
        }
      }

      if (newRequestDays === null) {
        newRequestDays = this.countWorkingDays(start, end);
      }

      // Urlopy rodzicielskie / ojcowskie
      if (Number(typ.ojcowski) === 1 && this.selectedChild) {
        //const totalLimit = (parseFloat(this.urlopyUser[0]?.ojcowski_dni) || 2);
		const typ = this.typyUrlopow.find(t => t.id === typeId);

const totalLimit = this.getLimitForChild(this.selectedChild, typ);
		const used = this.wnioskiOjcowskiAll
        .filter(req => req.dziecko === this.selectedChild)
        .reduce((acc, req) => {
         const daysCount = this.countDaysIncludingWeekends(req.start, req.end);
 		acc +=  Math.ceil(daysCount / 7);
          return acc;
        }, 0);
		
        const newRequestDaysIncludingWeekends = this.countDaysIncludingWeekends(start, end);
        const newRequestWeeks = newRequestDaysIncludingWeekends / 7;

        if (typ.do_roku != null) {
          const childDate = new Date(this.selectedChild);
          if (isNaN(childDate)) return { blocked: true, reasonCode: 'invalidChild' };

          const now = new Date(start);
          let wiek = now.getFullYear() - childDate.getFullYear();
          const m = now.getMonth() - childDate.getMonth();
          if (m < 0 || (m === 0 && now.getDate() < childDate.getDate())) {
            wiek--;
          }
        if (wiek >= Number(typ.do_roku)) {
            return { blocked: true, reasonCode: 'childTooOld' };
          }
        }
        if (used >= totalLimit) {
          return { blocked: true, reasonCode: 'limitUsedUp' };
        }
        if ((used + newRequestWeeks) > totalLimit) {
          return { blocked: true, reasonCode: 'weekLimit' };
        }
        if (newRequestWeeks < 1) {
          return { blocked: true, reasonCode: 'minOneWeek' };
        }
        return { blocked: false };
      }

      if (Number(typ.rodzicielski) === 1 && this.selectedChild) {
		const typ = this.typyUrlopow.find(t => t.id === typeId);
		const totalLimit = this.getLimitForChild(this.selectedChild, typ);

		const used = this.wnioskiRodzicielskiAll
        .filter(req => req.dziecko === this.selectedChild)
        .reduce((acc, req) => {
         const daysCount = this.countDaysIncludingWeekends(req.start, req.end);
 		acc +=  Math.ceil(daysCount / 7);
          return acc;
        }, 0);

        const newRequestDaysIncludingWeekends = this.countDaysIncludingWeekends(start, end);
        const newRequestWeeks =  Math.ceil(newRequestDaysIncludingWeekends / 7);

        if (typ.do_roku != null) {
          const childDate = new Date(this.selectedChild);
          if (isNaN(childDate)) return { blocked: true, reasonCode: 'invalidChild' };

          const now = new Date(start);
          let wiek = now.getFullYear() - childDate.getFullYear();
          const m = now.getMonth() - childDate.getMonth();
          if (m < 0 || (m === 0 && now.getDate() < childDate.getDate())) {
            wiek--;
          }

          if (wiek >= Number(typ.do_roku)) {
            return { blocked: true, reasonCode: 'childTooOld' };
          }
        }
        if (used >= totalLimit) {
          return { blocked: true, reasonCode: 'limitUsedUp' };
        }
        if ((used + newRequestWeeks) > totalLimit) {
          return { blocked: true, reasonCode: 'weekLimit' };
        }
        if (newRequestWeeks < 1) {
          return { blocked: true, reasonCode: 'minOneWeek' };
        }
        return { blocked: false };
      }

	if (typeId === 2) {
	  const usedDemandLeave = this.wnioskiUrlopowe.reduce((acc, req) => {
		if (req.typ_id === 2 && req.status === 1) {
		  const reqYear = new Date(req.start).getFullYear();
		  if (reqYear === currentYear) {
			acc += this.countWorkingDays(req.start, req.end);
		  }
		}
		return acc;
	  }, 0);
	const maxDemandLeave = 4;
	const remainingDemandDays = maxDemandLeave - usedDemandLeave;
	if (remainingDemandDays <= 0) {
		return { blocked: true, reasonCode: 'dayLimitDemandOnly' };
	}
  const actualRequestDays = Math.min(newRequestDays, remainingDemandDays);
  return { blocked: false, allowedDays: actualRequestDays };
}

      if (typeId === 27) {
        const usedDemandLeave = this.wnioskiUrlopowe.reduce((acc, req) => {
          if (req.typ_id === 27 && req.status === 1) {
            const reqYear = new Date(req.start).getFullYear();
            if (reqYear === currentYear) {
              acc += this.countWorkingDays(req.start, req.end);
            }
          }
          return acc;
        }, 0);
        if ((usedDemandLeave + newRequestDays) > 5) {
          return { blocked: true, reasonCode: 'dayLimit' };
        }
        const limit = (this.localTenRok || 0) + (this.localPoprzedniRok || 0);
        if (!limit) {
          return { blocked: true, reasonCode: 'dayLimit' };
        }
        const used = this.wnioskiUrlopowe.reduce((acc, req) => {
          if ((req.typ_id === 27) && req.status === 1) {
            const reqYear = new Date(req.start).getFullYear();
            if (reqYear === currentYear || reqYear === currentYear - 1) {
              acc += this.countWorkingDays(req.start, req.end);
            }
          }
          return acc;
        }, 0);

        if ((used + newRequestDays) > limit) {
          return { blocked: true, reasonCode: 'dayLimit' };
        }
        return { blocked: false };
      }

	  
      if (typeId === 24) {
        if (newRequestDays > this.localDniZeszyt) {
          return { blocked: true, reasonCode: 'dayLimit' };
        }
        return { blocked: false };
      }


if (typeId === 1) {

    const currentYear = new Date().getFullYear();

    const limit =
        (this.localTenRok || 0) +
        (this.localPoprzedniRok || 0);

    const used = this.wnioskiUrlopowe.reduce((acc, req) => {

        if (
            [1, 2, 25, 27].includes(Number(req.typ_id)) &&
            Number(req.status) === 1
        ) {
            const start = new Date(req.start);
            const end = new Date(req.end);

            const yearStart = new Date(currentYear, 0, 1);
            const yearEnd = new Date(currentYear, 11, 31);

            const realStart = start < yearStart ? yearStart : start;
            const realEnd = end > yearEnd ? yearEnd : end;

            if (realStart <= realEnd) {
                acc += this.countWorkingDays(realStart, realEnd);
            }
        }

        return acc;

    }, 0);

    // Wyliczamy tylko dni nowego wniosku przypadające na bieżący rok
    const requestStart = new Date(start);
    const requestEnd = new Date(end);

    const yearStart = new Date(currentYear, 0, 1);
    const yearEnd = new Date(currentYear, 11, 31);

    const realStart = requestStart < yearStart
        ? yearStart
        : requestStart;

    const realEnd = requestEnd > yearEnd
        ? yearEnd
        : requestEnd;

    let newRequestCurrentYear = 0;

    if (realStart <= realEnd) {
        newRequestCurrentYear = this.countWorkingDays(
            realStart,
            realEnd
        );
    }

    if (used + newRequestCurrentYear > limit) {
        return {
            blocked: true,
            reasonCode: 'dayLimit'
        };
    }

    return { blocked: false };
}

      // opcje
      if (seloptionID != null) {
        const opcjeForType = this.opcjeUrlopow[typeId];
        if (!Array.isArray(opcjeForType)) return { blocked: false };

        const opcja = opcjeForType.find(o => o.id === seloptionID);
        if (!opcja) return { blocked: false };

        const { liczba, dni_tygodni } = opcja;
        let used = 0;

        this.wnioskiUrlopowe.forEach(req => {
          if (req.typ_id === typeId && req.status === 1 && req.opcja === seloptionID && new Date(req.start).getFullYear() === currentYear) {
            const workingDays = this.countWorkingDays(req.start, req.end);
            used += dni_tygodni === 1 ? workingDays / 5 : workingDays;
          }
        });

        const now = dni_tygodni === 1 ? newRequestDays / 5 : newRequestDays;
        if ((used + now) > liczba) {
          return { blocked: true, reasonCode: 'optionExceeded' };
        }

        return { blocked: false };
      }

      // Inne typy — wiek dziecka
      if (typ.do_roku != null && this.selectedChild) {
        const childDate = new Date(this.selectedChild);
        if (isNaN(childDate)) return { blocked: true, reasonCode: 'invalidChild' };

        const now = new Date(start);
        let wiek = now.getFullYear() - childDate.getFullYear();
        const m = now.getMonth() - childDate.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < childDate.getDate())) {
          wiek--;
        }

        if (wiek >= Number(typ.do_roku)) {
          return { blocked: true, reasonCode: 'childTooOld' };
        }
      }

      let used = 0;
      this.wnioskiUrlopowe.forEach(req => {
        if (req.typ_id === typeId && req.status === 1 && new Date(req.start).getFullYear() === currentYear) {
          const workingDays = this.countWorkingDays(req.start, req.end);
          switch (typ.dni_tygodni) {
            case 1: used += workingDays / 5; break;
            case 2: used += workingDays / 21; break;
            default: used += workingDays;
          }
        }
      });

      const now = typ.dni_tygodni === 1 ? newRequestDays / 5 :
        typ.dni_tygodni === 2 ? newRequestDays / 21 : newRequestDays;

      if ((used + now) > typ.liczba) {
        return { blocked: true, reasonCode: 'dayLimit' };
      }
      return { blocked: false };
    },


    onLeaveTypeChange() {
      const selected = this.typyUrlopow.find(t => t.id === Number(this.newLeave.id));
      this.selectedTypeId = selected ? selected.id : null;
      this.selectedOption = '';
    },
    onDateRangeChange(args) {
      const [start, end] = args.value;
      this.newLeave.start = this.formatDateToYMD(start);
      this.newLeave.end = this.formatDateToYMD(end);
      this.workingDaysCount = this.countWorkingDays(start, end);
      this.workingWeeksCount = this.workingDaysCount / 5;
    },

    countWorkingDays(startDate, endDate) {
      let count = 0;
      const holidaysCache = {};

      let current = this.toLocalDate(startDate);
      const end = this.toLocalDate(endDate);

      while (current <= end) {
        const day = current.getDay();
        const year = current.getFullYear();

        if (!holidaysCache[year]) {
          holidaysCache[year] = this.getPolishHolidays(year);
        }

        const dateStr = this.formatDate(current);
        const isWeekend = day === 0 || day === 6;
        const isHoliday = holidaysCache[year].includes(dateStr);

        if (!isWeekend && !isHoliday) {
          count++;
        }

        current.setDate(current.getDate() + 1);
      }

      return count;
    },

    countDaysIncludingWeekends(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffTime = endDate - startDate;
      return Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1; // liczba dni kalendarzowych, włącznie z weekendami
    },

submitLeave() {
  const { start, end, id } = this.newLeave;
  const seloptionID = this.selectedOption;
  this.formError = false;

  const podpisDataUrl = this.signaturePad.toDataURL('image/png');

  // --- Podpis ---
  if (!this.signaturePad || this.signaturePad.isEmpty()) {
    this.showToast('error', 'Błąd', 'Dodaj podpis przed zapisaniem.');
    return;
  }

  // --- Walidacja dat ---
  if (!start || !end || !id || new Date(start) > new Date(end)) {
    this.formError = true;
    Toast.fire({
      icon: 'error',
      title: 'Błąd w danych',
      text: 'Upewnij się, że wypełniłeś poprawnie wszystkie pola.',
    });
    return;
  }

  const typ = this.typyUrlopow.find(t => t.id === id);
  if (!typ) return;

  // --- LICZENIE DNI ROBOCZYCH ---
  const startDate = new Date(start);
  const endDate = new Date(end);
  const selectedYear = this.selectedYear;

  const startOfYear = new Date(selectedYear, 0, 1);
  const endOfYear = new Date(selectedYear, 11, 31);

  let workingDaysInSelectedYear = 0;
  let workingDaysNextYear = 0;

  if (endDate >= startOfYear && startDate <= endOfYear) {
    const startCalc = startDate < startOfYear ? startOfYear : startDate;
    const endCalc = endDate > endOfYear ? endOfYear : endDate;
    workingDaysInSelectedYear = this.countWorkingDays(startCalc, endCalc);
  }

  const startNextYear = new Date(selectedYear + 1, 0, 1);
  if (endDate >= startNextYear) {
    const startCalc = startDate < startNextYear ? startNextYear : startDate;
    const endCalc = endDate;
    workingDaysNextYear = this.countWorkingDays(startCalc, endCalc);
  }

  // --- WALIDACJA LIMITU DLA URLOPU WYP0CZYNKOWEGO ---
if (typ.wypoczynkowy === 1 || Number(typ.id) === 2) {

    const currentYear = new Date().getFullYear();

    const availableDaysThisYear =
        (this.localTenRok || 0) +
        (this.localPoprzedniRok || 0) -
        (this.wykorzystanychDniWolnych || 0);

    // Wyznaczamy tylko część wniosku przypadającą na bieżący rok
    const yearStart = new Date(currentYear, 0, 1);
    const yearEnd = new Date(currentYear, 11, 31);

    const realStart =
        startDate < yearStart ? yearStart : startDate;

    const realEnd =
        endDate > yearEnd ? yearEnd : endDate;

    let workingDaysCurrentYear = 0;

    if (realStart <= realEnd) {
        workingDaysCurrentYear = this.countWorkingDays(
            realStart,
            realEnd
        );
    }

    // Sprawdzamy limit tylko wtedy, gdy wniosek obejmuje bieżący rok
    if (
        workingDaysCurrentYear > 0 &&
        workingDaysCurrentYear > availableDaysThisYear
    ) {
        this.formError = true;

        Toast.fire({
            icon: 'error',
            title: 'Limit dni przekroczony',
            text: `W ${currentYear} roku masz jeszcze ${availableDaysThisYear} dni urlopu, a próbujesz wykorzystać ${workingDaysCurrentYear}.`,
        });

        return;
    }
}

  // --- WALIDACJA DLA URLOPU NA ŻĄDANIE ---
  if (typ.id === 2) {
    const maxDemandLeave = 4;

    const usedDemandLeave = this.wnioskiUrlopowe.reduce((acc, req) => {
      if (req.typ_id === 2 && req.status === 1) {
        const reqYear = new Date(req.start).getFullYear();
        if (reqYear === selectedYear) {
          acc += this.countWorkingDays(req.start, req.end);
        }
      }
      return acc;
    }, 0);

    if ((usedDemandLeave + workingDaysInSelectedYear) > maxDemandLeave) {
      this.formError = true;
      Toast.fire({
        icon: 'error',
        title: 'Limit dni urlopu na żądanie',
        text: `W ${selectedYear} roku nie możesz wziąć więcej niż ${maxDemandLeave} dni urlopu na żądanie.`,
      });
      return;
    }

    // --- Nic nie przycinamy, nie patrzymy na limit wypoczynkowy ---
  }

  // --- suma dni do zapisu ---
  this.wolneDni = workingDaysInSelectedYear + workingDaysNextYear;

  // --- POZOSTAŁE WALIDACJE ---
  const { blocked, reasonCode } = this.shouldBlockSpecialLeave(
    id,
    start,
    end,
    seloptionID,
    this.wolneDni
  );

  if (blocked) {
    let reason = 'Nie możesz złożyć tego wniosku urlopowego.';

    switch (reasonCode) {
      case 'minOneWeek':
        reason = 'Urlop ojcowski lub rodzicielski musi trwać co najmniej 7 dni kalendarzowych.';
        break;
      case 'overlapExists':
        reason = 'W tym okresie urlopu już istnieje inny wniosek.';
        break;
      case 'weekLimit':
        reason = `Przekroczono limit tygodni urlopu typu "${typ?.nazwa}".`;
        break;
      case 'dayLimit':
        reason = `Przekroczony limit dni dla urlopu typu "${typ?.nazwa}".`;
        break;
      case 'childTooOld':
        reason = `Wybrane dziecko ma więcej niż ${typ?.do_roku} lat.`;
        break;
      case 'invalidChild':
        reason = 'Nie wybrano lub podano błędne dane dziecka.';
        break;
      case 'optionExceeded':
        reason = `Przekroczono limit dla wybranej opcji urlopu typu "${typ?.nazwa}".`;
        break;
    }

    if (this.shouldSelectChild && !this.selectedChild) {
      this.formError = true;
      Toast.fire({
        icon: 'error',
        title: 'Brak dziecka',
        text: 'Wybierz dziecko, na które ma być przyznany urlop.',
      });
      return;
    }

    this.formError = true;
    Toast.fire({
      icon: 'error',
      title: 'Nie można dodać urlopu',
      text: reason,
    });
    return;
  }

  // --- ZAPIS DO BACKENDU ---
  const typeName = this.getTypeNameById(id);
  const optionName = this.getOptionNameById(seloptionID);
  const fullType =
    this.hasOptionsForSelectedType && seloptionID
      ? `${typeName} - ${optionName}`
      : typeName;

  axios.post(route('urlopy.store'), {
    start,
    end,
    type: fullType,
    wolnedni: this.wolneDni,
    podpis: podpisDataUrl,
    dziecko: this.selectedChild || null
  })
    .then(() => {
      this.fetchWnioski();

      this.wnioskiUrlopowe.push({
        start,
        end,
        type: fullType,
        status: 'Oczekuje',
        wolnedni: this.wolneDni,
      });

      this.newLeave = { start: '', end: '', id: '', wolnedni: '' };
      this.selectedOption = '';
      this.selectedTypeId = null;
      this.selectedChild = '';
      this.closeModal();

      Toast.fire({
        icon: 'success',
        title: 'Wniosek został dodany',
      });
    })
    .catch(() => {
      this.formError = true;
      Toast.fire({
        icon: 'error',
        title: 'Błąd serwera',
        text: 'Nie udało się zapisać wniosku urlopowego.',
      });
    });
},

    submitLeave2() {
      this.formError = false;
      const { start, end } = this.newLeave;

      if (!start || !end) {
        this.formError = true;
        Toast.fire({
          icon: 'error',
          title: 'Brak daty',
          text: 'Wybierz zakres dat delegacji.',
        });
        return;
      }

      if (!this.form.lokalizacja || this.form.lokalizacja.trim() === '') {
        this.formError = true;
        Toast.fire({
          icon: 'error',
          title: 'Brak lokalizacji',
          text: 'Wpisz lokalizację delegacji.',
        });
        return;
      }

      if (!this.form.celDelegacji || this.form.celDelegacji.trim() === '') {
        this.formError = true;
        Toast.fire({
          icon: 'error',
          title: 'Brak celu',
          text: 'Podaj cel delegacji.',
        });
        return;
      }


      this.wolneDni = this.countWorkingDays(start, end);

      const payload = {
        start: start,
        end: end,
        pracownicy: this.form.delegacjaPracownicy.map(p => p.id),
        wolnedni: this.wolneDni,
        type: `Delegacja:${this.form.lokalizacja ? ' <strong>' + this.form.lokalizacja + '' : ''}${this.form.celDelegacji ? '</strong><br>' + this.form.celDelegacji : ''}`,
      };

      //console.log('Delegacja:', payload);

      axios.post(route('delegacja.store'), payload)
        .then(() => {
          this.fetchWnioski();
          Toast.fire({
            icon: 'success',
            title: 'Delegacja dodana',
          });

          this.newLeave = { start: '', end: '', id: '', wolnedni: '' };
          this.form.delegacjaPracownicy = [];
          this.wolneDni = '';

          this.closeModal2();
        })
        .catch(error => {
          if (error.response && error.response.status === 422 && error.response.data.details) {
            const names = error.response.data.details.join(', ');
            Toast.fire({
              icon: 'error',
              title: 'Konflikt delegacji',
              text: `Pracownicy z kolizją: ${names}`,
            });
          } else {
            Toast.fire({
              icon: 'error',
              title: 'Błąd serwera',
              text: 'Nie udało się zapisać delegacji.',
            });
          }
          this.formError = true;
        });
    },

    timeStringToHours(time) {
      if (!time) return 0;

      const [h, m] = time.split(':').map(Number);
      return h + (m / 60);
    },

submitLeaveP() {
  //console.log('--- submitLeaveP START ---');
  this.formError = false;

  if (!this.created_at) {
    //console.warn('Odrzucono: brak created_at');
    this.formError = true;
    Toast.fire({ icon: 'error', title: 'Brak daty utworzenia', text: 'Wybierz datę utworzenia wniosku.' });
    return;
  }

  if (!this.data_out) {
    //console.warn('Odrzucono: brak data_out');
    this.formError = true;
    Toast.fire({ icon: 'error', title: 'Brak daty wyjścia', text: 'Wybierz datę opuszczenia stanowiska pracy.' });
    return;
  }

  if (!this.godzina_start) {
    console.warn('Odrzucono: brak godzina_start');
    this.formError = true;
    Toast.fire({ icon: 'error', title: 'Brak godziny wyjścia', text: 'Wybierz godzinę opuszczenia stanowiska pracy.' });
    return;
  }

  if (!this.ile_godzin) {
    //console.warn('Odrzucono: brak ile_godzin');
    this.formError = true;
    Toast.fire({ icon: 'error', title: 'Brak liczby godzin', text: 'Podaj liczbę godzin.' });
    return;
  }

  if (!this.signaturePad || this.signaturePad.isEmpty()) {
    //console.warn('Odrzucono: brak podpisu');
    this.showToast('error', 'Błąd', 'Dodaj podpis przed zapisaniem.');
    return;
  }

  const conflictCheck = this.checkPassConflict(this.data_out, this.data_out, this.select);

  if (conflictCheck.blocked) {
    //console.warn('Odrzucono: konflikt przepustki', conflictCheck.reason);
    this.formError = true;
    Toast.fire({
      icon: 'error',
      title: 'Nie można dodać wniosku',
      text: conflictCheck.reason,
    });
    return;
  }

  const timeStringToHours = (time) => {
    if (!time) return 0;
    const [h, m] = time.split(':').map(Number);
    return h + m / 60;
  };

  const dostepneGodziny = timeStringToHours(this.localGodzinyPrzepustki);

  const wymaganeGodziny = parseFloat(
    String(this.ile_godzin).replace(',', '.')
  );

  //console.log('Dostępne godziny:', dostepneGodziny);
  //console.log('Wymagane godziny:', wymaganeGodziny);

  const sendRequest = async () => {
    try {
      //console.log('Wysyłanie wniosku do backendu...');

      await axios.post(route('urlopy.przepustka.store'), {
        created_at: this.created_at,
        data_out: this.data_out,
        godzina_start: this.godzina_start,
        ile_godzin: wymaganeGodziny,
        select: this.select,
        podpis: this.signaturePad.toDataURL('image/png'),
      });

      //console.log('Wniosek zapisany poprawnie');

      this.fetchWnioski();
      this.created_at = '';
      this.data_out = '';
      this.godzina_start = '';
      this.ile_godzin = '';
      this.select = '';
      this.signaturePad.clear();
      this.closeModalP();

      Toast.fire({
        icon: 'success',
        title: 'Wniosek o przepustkę został dodany',
      });

    } catch (err) {
      console.error('Błąd zapisu przepustki:', err);

      if (err.response) {
        console.error('Status:', err.response.status);
        console.error('Dane błędu:', err.response.data);
      }

      Toast.fire({
        icon: 'error',
        title: 'Błąd serwera',
        text: 'Nie udało się zapisać wniosku o przepustkę.',
      });
    }
  };

  if (this.select == 1 && wymaganeGodziny > dostepneGodziny) {

    //console.warn('Brak wystarczających godzin – próba pobrania dnia urlopu');

    const dostepneDniUrlopu = this.localTenRok + this.localPoprzedniRok - (this.wykorzystanychDniWolnych || 0);

    //console.log('Dostępne dni urlopu:', dostepneDniUrlopu);

    if (dostepneDniUrlopu < 1) {
      //console.warn('Odrzucono: brak dni urlopu do pobrania');

      this.formError = true;
      Toast.fire({
        icon: 'error',
        title: 'Brak dni urlopu',
        text: 'Nie posiadasz żadnego dnia urlopu wypoczynkowego do pobrania na poczet przepustki.',
      });
      return;
    }

    Toast.fire({
      toast: false,
      icon: 'warning',
      title: 'Brak wystarczającej liczby godzin',
      html: `
        Nie posiadasz wystarczającej liczby godzin na przepustki.<br>
        <b>Zostanie pobrany 1 dzień urlopu wypoczynkowego</b> na poczet przepustki.<br><br>
        Czy chcesz kontynuować?
      `,
      showDenyButton: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      timer: false,
      position: 'center',
      showConfirmButton: true,
      confirmButtonText: 'Tak',
      denyButtonText: 'Nie',
    }).then((result) => {

      if (result.isConfirmed) {
        //console.log('Użytkownik potwierdził pobranie dnia urlopu');
        sendRequest();
      } else {
        //console.warn('Użytkownik anulował operację');
      }

    });

    return;
  }

 // console.log('Brak konfliktów – wysyłam normalnie');
  sendRequest();
},
    async usun(id) {
      if (!confirm('Czy na pewno chcesz usunąć ten wniosek?')) return;

      try {
        await axios.delete(route('urlopy.destroy', id));
        this.fetchWnioski();
        Toast.fire({
          icon: 'success',
          title: 'Wniosek usunięty',
          text: 'Wniosek został usunięty.',
        });
        this.fetchWnioski();
      } catch (err) {
        console.error(err);
        Toast.fire({
          icon: 'error',
          title: 'Błąd',
          text: 'Nie udało się usunąć wniosku.',
        });
      }


    },

    async usunP(id) {
      if (!confirm('Czy na pewno chcesz usunąć ten wniosek?')) return;

      try {
        await axios.delete(route('urlopy.przepustka.destroy', id));
        this.fetchWnioski();
        Toast.fire({
          icon: 'success',
          title: 'Wniosek usunięty',
          text: 'Wniosek został usunięty.',
        });
        this.fetchWnioski();
      } catch (err) {
        console.error(err);
        Toast.fire({
          icon: 'error',
          title: 'Błąd',
          text: 'Nie udało się usunąć wniosku.',
        });
      }


    },


    formatDateToYMD(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatDateToDisplay(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      return date.toLocaleDateString('pl-PL');
    },
    editCreatedPrzepustkaDate(id) {
      this.editingIdP = id;
      //console.log('Edytowane id:', this.editingIdP);
    },

    editCreatedDate(id) {
      this.editingId = id;
      //console.log('Edytowane id:', this.editingId);
    },

    async updateCreatedDate(item) {
      //console.log("Zapisuję nową datę:", item.created_at);
      //console.log("Zapisuję dla id :", item.id);
      try {
        await axios.put(route('urlopy.updateCreatedDate', item.id), {
          created_at: item.created_at,
        });
        this.showToast('success', 'Zapisano', 'Data została zaktualizowana.');
        this.editingId = null;
        this.fetchWnioski();
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać daty.');
      }
    },

    async updateCreatedDateP(item) {
      //console.log("Zapisuję nową datę:", item.created_at);
      //console.log("Zapisuję dla id :", item.id);
      try {
        await axios.put(route('urlopy.updateCreatedPrzepustkaDate', item.id), {
          created_at: item.created_at,
        });
        this.showToast('success', 'Zapisano', 'Data została zaktualizowana.');
        this.editingIdP = null;
        this.fetchWnioski();
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać daty.');
      }
    },
	
checkPassConflict(created_at, data_out, select) {
  const newStart = new Date(created_at);
  const newEnd = new Date(data_out);

  for (const req of this.wnioskiUrlopowe) {
    if (req.status === 2 || req.status === 3) continue; // pomiń odrzucone/anulowane

    const reqStart = new Date(req.start || req.created_at);
    const reqEnd = new Date(req.end || req.data_out);

    // uwzględnij kolizję w przypadku, gdy przepustka ma pobrać dzień urlopu
    if (newStart <= reqEnd && newEnd >= reqStart) {
      return { blocked: true, reason: 'Kolizja z innym wnioskiem urlopowym lub delegacją.' };
    }
  }

  // dodatkowa weryfikacja dla select == 1 (pobranie dnia urlopu)
  if (select == 1) {
    const availableDays = (this.localTenRok || 0) + (this.localPoprzedniRok || 0) - (this.wykorzystanychDniWolnych || 0);
    if (availableDays < 1) {
      return { blocked: true, reason: 'Nie posiadasz żadnego dnia urlopu wypoczynkowego do pobrania na poczet przepustki.' };
    }
  }

  return { blocked: false };
},

    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};
</script>
<style scoped>
.card-title {
  font-weight: bold;
}

.card-calendar {
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

.calendar-container {
  overflow-x: auto;
  max-width: 420px;
  margin: 0 auto;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 0.75rem;
}

.calendar-table th,
.calendar-table td {
  height: 40px;
  width: 40px;
  padding: 0;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #dee2e6;
  box-sizing: border-box;
}

.week-header {
  background-color: #f1f1f1;
  width: 30px;
  font-weight: bold;
  font-size: 0.7rem;
}

.week-number {
  color: #6c757d;
  font-size: 0.7rem;
}

.bg-weekend {
  background-color: #f8f9fa !important;
  color: #adb5bd;
}

.calendar-legend .legend-item div {
  border-radius: 3px;
}

.select-month-year select {
  min-width: 100px;
}

.bg-holiday {
  background-color: #eee3e3 !important;
}

.signature-canvas {
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 1;
  border: 2px solid #0dcaf0;
  border-radius: 10px;
  background: #fff;
  max-width: 90vw;
}
</style>